import { createAction, props } from '@ngrx/store';
import { GetMyWatchedItems200Response } from '@viewbid/ts-angular-client';

/**
 * Action to load the watchlist with pagination.
 */
// eslint-disable-next-line
export const loadWatchlist = createAction(
    '[Watchlist Page] Load Watchlist',
    props<{ page: number; pageSize: number; query?: string }>(),
);

/**
 * Action dispatched when the watchlist is successfully loaded.
 */
// eslint-disable-next-line
export const loadWatchlistSuccess = createAction(
    '[Watchlist Page] Load Watchlist Success',
    props<{ response: GetMyWatchedItems200Response }>(),
);

/**
 * Action dispatched when there is a failure in loading the watchlist.
 */
// eslint-disable-next-line
export const loadWatchlistFailure = createAction(
    '[Watchlist Page] Load Watchlist Failure',
    props<{ error: Error }>(),
);

// eslint-disable-next-line
export const refreshWatchlistCount = createAction('[Watchlist] Refresh Count');

// eslint-disable-next-line
export const watchlistUserChanged = createAction('[Watchlist] User Changed');

// eslint-disable-next-line
export const watchlistTotalLoaded = createAction(
    '[Watchlist Page] Total Loaded',
    props<{ totalCount: number }>(),
);

/**
 * Action to add an item to the watchlist.
 */
// eslint-disable-next-line
export const addToWatchlist = createAction(
    '[Watchlist Page] Add Item',
    props<{ watchlistId: string }>(),
);

/**
 * Action to remove an item from the watchlist.
 */
// eslint-disable-next-line
export const removeFromWatchlist = createAction(
    '[Watchlist Page] Remove Item',
    props<{ watchlistId: string }>(),
);
